import { useEffect, useState } from 'react';
import CustomDataTable from './DataTable';
import CustomPaginator from '../paginator/CustomPaginator';

const ServerParentDataTable = ({
    value, columns, rows, filters, loading, globalFilterFields, archiveKey,onFilter, isServerSide = false, pageChange, totalRecords}) => {

        const [ first, setFirst] = useState(0)
        const handleOnChange = (event) => {
                setFirst(event.first)
                pageChange(event)
            }

            useEffect(() => {
             setFirst(0)
              }, [rows])       
    return (
        <>
        <CustomDataTable
                value={value}
                columns={columns}
                paginator={true}
                rows={rows}
                filters={isServerSide ? {} : filters}
                loading={loading}
                globalFilterFields= {globalFilterFields}
                onPageChange={handleOnChange}
                archiveKey={archiveKey}
                onFilter={isServerSide ? onFilter : ''}
                isServerSide={isServerSide}
            />
            <CustomPaginator
                totalRows={totalRecords}
                rowsCount={rows}
                first={first}
                onPageChange={handleOnChange}
            />
        </>
    );
};

export default ServerParentDataTable;